module.exports = __webpack_public_path__ + "img/9.7ec1e40e.svg";